import React, { useState, useEffect } from 'react';
import DashBoardRightContainer from '@components/salesDashBoard/DashBoardRightContainer';
import DashBoardHeader from '@components/salesDashBoard/DashBoardHeader';
import NotificationModal from '@components/common/NotificationModal';
import dayjs from 'dayjs';
import Cookies from 'js-cookie';
import { useGetNotification } from '@hooks/notification/useGetNotification';
import { isDemoSession } from '@services/demo/demoAccount';

const SalesDashboard = () => {
  const {
    notificationData,
    showNotificationModal,
    separateModalHandler,
    hideModalForAWeek,
    toggleHideModalForAWeekHandler,
  } = useGetNotification();

  return (
    <div id="sales_dashboard_container">
      <DashBoardHeader />
      {/*<DashBoardLeftNavBar />*/}
      <DashBoardRightContainer />
      {!isDemoSession() && (
        <NotificationModal
          notificationData={notificationData}
          show={showNotificationModal}
          onHide={separateModalHandler}
          hideDay={hideModalForAWeek}
          onToggleHideDay={toggleHideModalForAWeekHandler}
        />
      )}
    </div>
  );
};

export default SalesDashboard;
